import React, { useEffect, useState, useContext, useRef } from 'react'
import _ from "lodash"
import { useTranslation } from 'react-i18next'

import { UserContext } from "context/auth";

import FormGenerator from 'main_views/form/request/fromGenerator'
import Modal from 'main_views/components/Modal'
import Alert from "main_views/components/alert"
import { addDoc, getImageUrl, updateDoc } from 'dbHandler'
import { handleTicket } from "main_views/Tasks/handler"
import { successToast, errorToast } from 'main_views/components/toast'
import ticketData from './ticketData'

function ReRequestModal(props) {

   let { t } = useTranslation()
   let { user: currentUser } = useContext(UserContext)

   let { toggle, reRequestForm } = props

   let formGeneratorRef = useRef()

   let [selectedForm, setSelectedForm] = useState(reRequestForm)
   let [isSaving, setIsSaving] = useState(false)
   let [alert, setAlert] = useState(null)

   let discardFormChanges = () => {
      setAlert({
         show: true,
         isWarning: true,
         title: t('confirm_discard_changes'),
         msg: t('are_you_sure_you_want_to_discard_all_changes'),
         confirmBtnText: t('yes_discard_changes'),
         cancelBtnText: t('cancel'),
         showCancelBtn: true,
         handelCancel: () => setAlert(null),
         handelConfirm: () => {
            setAlert(null)
            setSelectedForm(null)
            toggle()
         },
      })
   }

   let sendReRequest = async () => {
      setIsSaving(true)

      try {

         let { formData, isValid } = formGeneratorRef.current.getData()

         if (!isValid)
            return errorToast(t('please_complete_the_form'))

         ticketData.openedAt = window.fsTimestamp
         ticketData.formId = _.get(selectedForm, 'formId')
         ticketData.getwayId = _.get(selectedForm, 'getwayId')
         ticketData.form.data = _.values(formData)
         ticketData.form.name = _.get(selectedForm, 'form.name')
         ticketData.reminderDays = _.get(selectedForm, 'reminderDays')

         ticketData.requestedBy = currentUser.id
         ticketData.requesterName = currentUser.name_en

         ticketData.priority = _.get(formData, 'priority.value', '')
         ticketData.dueDate = _.get(formData, 'dueDate.value', '')

         // re-directed staffs ids
         ticketData.directedStaffs = _.map(_.get(formData, 'directedStaffs.value'), 'value', [])

         if (!_.isEmpty(ticketData.directedStaffs)) {
            // push the current user id at the end of directedStaffs list
            let { id: currentUserId } = currentUser
            ticketData.directedStaffs.push(currentUserId)
         }

         let db = window.firebaseFirestore
         let ticketsCurrentCounter = await db.doc('counter/tickets').get()

         // set the ticket number based on the tickets Counter
         ticketsCurrentCounter = ticketsCurrentCounter.data().counter
         ticketsCurrentCounter++
         ticketData.number = ticketsCurrentCounter

         await handleTicket(ticketData, true) // to add getwayIds to the ticket
         let ticketNumber = (ticketsCurrentCounter).toLocaleString('en-US', { minimumIntegerDigits: 6, useGrouping: false }) // set the ticket number in 6 digits

         ticketData.number = ticketNumber
         console.log({ticketData})

         let increment = window.firebaseIncrement

         // save the data & update the counter
         let [doc, counter] = await Promise.all([
            addDoc(ticketData, `tickets`),
            updateDoc({ counter: increment }, 'counter/tickets')
         ])

         // save the ticket files
         let pfInput = document.querySelector('#files')?.files ?? []
         let files = Array.prototype.slice.call(pfInput)

         if (!_.isEmpty(files)) {

            let url = `tickets/${doc.id}`

            // Array of "Promises"
            let urls = await Promise.all(
               files.map(file => getImageUrl(file, `${url}/${file.name}`))
            )

            let filesUrls = _.map(urls, (url, idx) => ({
               name: files[idx].name,
               url: url
            }))

            await updateDoc({ filesUrls }, url)

         }

         successToast(t('request_was_send'))
         setSelectedForm(null)
         toggle()

      } catch (error) {
         console.log("sendReRequest -> error", error)

         errorToast(t('something_wrong'))

      } finally {

         setIsSaving(false)
      }

   }

   return (
      <Modal
         isOpen={!_.isEmpty(selectedForm)}
         toggle={discardFormChanges}
         title={`${_.get(selectedForm, 'form.name')}`}
         subTitle={t('re_request')}
         removeBodyPaddings={true}
         hasFooter={true}
         isSaving={isSaving}
         onSave={sendReRequest}
         saveText={t('re_request')}
      >

         <div style={{ minHeight: '50vh', display: 'grid' }}>

            <FormGenerator
               form={_.get(selectedForm, 'form')}
               ref={formGeneratorRef}
            />

         </div>

         <Alert {...alert} />
      </Modal>
   )
}

export default ReRequestModal
